<template>
  <Teleport
    to="#modals"
    v-if="show">
    <transition
      enter-active-class="animate__animated animate__slideInDown animate__faster"
      leave-active-class="animate__animated animate__slideOutUp animate__faster"
      appear>
      <div
        class="modal fade in"
        ref="modal"
        tabindex="-1"
        role="dialog"
        @click="outsideClick"
        v-show="show">
        <div
          class="modal-dialog"
          :class="dialogClasses"
          role="document">
          <div class="modal-content">
            <slot>
              <div class="modal-header">
                <LinkText
                  as="button"
                  type="button"
                  class="close"
                  aria-label="Close"
                  @click="cancel">
                  <span aria-hidden="true">&times;</span>
                </LinkText>
                <h4 class="modal-title">Modal title</h4>
              </div>
              <div class="modal-body">
                <p>One fine body&hellip;</p>
              </div>
              <div class="modal-footer">
                <ButtonDefault
                  type="button"
                  @click="cancel">
                  Close
                </ButtonDefault>
                <ButtonPrimary type="button"> Save changes </ButtonPrimary>
              </div>
            </slot>
          </div>
        </div>
      </div>
    </transition>

    <transition
      enter-active-class="animate__animated animate__fadeIn50"
      leave-active-class="animate__animated animate__fadeOut50"
      appear>
      <div
        class="modal-backdrop fade in"
        ref="backdrop"
        v-if="backdrop && show"></div>
    </transition>
  </Teleport>
</template>

<script>
import ButtonPrimary from '@/components/buttons/ButtonPrimary.vue';
import ButtonDefault from '@/components/buttons/ButtonDefault.vue';
import LinkText from '@/components/links/LinkText.vue';

export default {
  components: { LinkText, ButtonDefault, ButtonPrimary },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    keyboard: {
      default: true,
      type: Boolean,
    },
    backdrop: {
      default: true,
      type: [Boolean, String],
      validator: (value) => {
        return typeof value === 'boolean' || value === 'static';
      },
    },
    dialogClasses: String,
  },
  emits: ['close'],
  created() {
    if (!this.keyboard) {
      return;
    }

    document.addEventListener('keydown', this.escapeListener.bind(this));
  },
  beforeUnmount() {
    document.removeEventListener('keydown', this.escapeListener);
  },
  watch: {
    show: {
      immediate: true,
      handler: function (show) {
        if (show) {
          document.body.classList.add('modal-open');
        } else {
          document.body.classList.remove('modal-open');
        }
      },
    },
  },
  methods: {
    escapeListener(event) {
      if ((event.key === 'Escape' || event.key === 'Esc') && this.show) {
        this.cancel();
      }
    },
    cancel() {
      this.$emit('close');
    },
    outsideClick(event) {
      const outsideClick = event.target.classList.contains('modal');
      if (outsideClick && this.backdrop && this.backdrop !== 'static') {
        this.cancel();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  display: block;
}

@keyframes animate__fadeIn50 {
  from {
    opacity: 0;
  }
  to {
    opacity: 0.5;
  }
}

.animate__fadeIn50 {
  animation-name: fadeIn50;
  animation-duration: 0.5s;
}

@keyframes animate__fadeOut50 {
  from {
    opacity: 0.5;
  }
  to {
    opacity: 0;
  }
}

.animate__fadeOut50 {
  animation-name: fadeOut50;
  animation-duration: 0.2s;
}
</style>
